import React from 'react';

import { Skeleton as ShadcnSkeleton } from '@/components/ui/skeleton';
import { useConversations } from '../../hooks';

const Skeleton = () => (
  <div className="p-4 flex-1 overflow-y-auto space-y-2">
    <ShadcnSkeleton className="h-4 w-full" />
    <ShadcnSkeleton className="h-4 w-full" />
    <ShadcnSkeleton className="h-4 w-full" />
    <ShadcnSkeleton className="h-4 w-3/4" />
  </div>
);

const Message = () => {
  const { activeConversation, isLoadingActive: isLoading } = useConversations();

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <div className="p-4 flex-1 overflow-y-auto">
      <p className="text-sm whitespace-pre-line">
        {activeConversation.lastMessage.content}
      </p>
    </div>
  );
};

export default Message;
